<template>
  <div class="text-xl print:hidden">
    <span class="font-bold mr-2">{{ rating }}</span>
    <!-- These are the full yellow stars -->
    <div class="inline" v-if="frontGoldStars() > 0">
      <div class="inline" v-for="star in frontGoldStars()" :key="star">
        <span class="mdi mdi-star text-secondary text-yellow-600"></span>
      </div>
    </div>

    <!-- The star that has some gold and some gray -->
    <div class="inline" v-if="rating < 5">
      <div
        class="inline"
        v-for="(background_star, index) in 5 - Math.floor(rating)"
        :key="background_star"
      >
        <template v-if="index == 0">
          <span v-bind:style="middleStarCss" class="mdi mdi-star inline"></span>
        </template>
      </div>
    </div>

    <!-- The remaining gray stars -->
    <div class="inline" v-if="remainingGrayStars() > 0">
      <div class="inline" v-for="star in remainingGrayStars()" :key="star">
        <span class="mdi mdi-star text-secondary text-gray-600"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rating: {
      required: true
    }
  },
  methods: {
    transitionStarGoldPercent() {
      return (this.rating - Math.floor(this.rating)) * 100;
    },
    frontGoldStars() {
      return Math.floor(this.rating);
    },
    remainingGrayStars() {
      return 5 - Math.floor(this.rating) - 1;
    }
  },
  computed: {
    middleStarCss: function() {
      return {
        background:
          "linear-gradient(90deg, #D69E2E 0% " +
          this.transitionStarGoldPercent() +
          "%, #718096 " +
          this.transitionStarGoldPercent() +
          "% 100%)",
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent"
      };
    }
  }
};
</script>
